<div class="row mb-5">
  <div class="col-xxl-12">
    <div class="row">
      <div class="col-md-6">
        <div style="display: block;">
          <canvas baseChart width="200" height="150" [datasets]="lineChartDataSemanal" [labels]="lineChartLabelsSemanal"
            [options]="lineChartOptions" [colors]="lineChartColors" [legend]="lineChartLegend"
            [chartType]="lineChartTypeBar" [plugins]="lineChartPlugins">
          </canvas>
        </div>
      </div>
      <div class="col-md-6">
        <div style="display: block;">
          <canvas baseChart width="200" height="150" [datasets]="lineChartDataMensais" [labels]="lineChartLabelsMensais"
            [options]="lineChartOptions" [colors]="lineChartColors" [legend]="lineChartLegend"
            [chartType]="lineChartTypeLine" [plugins]="lineChartPlugins">
          </canvas>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="col-xxl-12">

</div>

<div class="row">
  <div class="col-xxl-9">

  </div>

  <div class="col-xxl-3">

  </div>
</div>

<div class="row">
  <div class="col-xxl-12 mb-5">
    <div class="row">
      <div class="col-md-6">
        <div style="display: block;">
          <canvas baseChart width="200" height="150" [datasets]="lineChartDataPendentes"
            [labels]="lineChartLabelsPendentes" [options]="lineChartOptions" [colors]="lineChartColors"
            [legend]="lineChartLegend" [chartType]="lineChartTypeBar" [plugins]="lineChartPlugins">
          </canvas>
        </div>
      </div>
      <div class="col-md-6 pt-5">
        <nb-card>
          <nb-card-body>
            <div class="card-sem_borda strpied-tabled-with-hover">
              <div class="card-header ">
                <h4 class="card-title fonte-Cabecalho_form">{{ 'Produtos Pendentes' | translate }}</h4>
              </div>

              <div class="card-body table-full-width table-responsive">
                <table class="table table-hover table-striped">
                  <thead>
                    <th class="text-center">{{'Produto' | translate}}</th>
                    <th class="text-center">{{'Aguardando' | translate}}</th>
                    <th class="text-center">{{'Problema Técnico' | translate}}</th>
                  </thead>
                  <tbody>
                    <tr *ngFor="let dado of listStatusProdutos">
                      <td class="text-center">{{dado[0].Tipo}}</td>
                      <td class="text-center">{{dado[0].TotalAguardando}}</td>
                      <td class="text-center">{{dado[0].TotalProblemaTecnico}}</td>
                    </tr>
                  </tbody>
                </table>
                <hr>

              </div>
            </div>
          </nb-card-body>
        </nb-card>
      </div>
    </div>
  </div>

  <div class="col-xxl-12" *ngIf="usuario.EmpresaId">
    <nb-card>
      <nb-card-body>
        <div class="card-sem_borda strpied-tabled-with-hover">
          <div class="card-header ">
            <h4 class="card-title fonte-Cabecalho_form">{{'Agências Inativas' | translate}}</h4>
          </div>

          <div class="card-body table-full-width table-responsive">
            <table class="table table-hover table-striped">
              <thead>
                <th>ID</th>
                <th>{{'Razão Social' | translate}}</th>
                <th>{{'Nome Fantasia' | translate}}</th>
              </thead>
              <tbody>
                <tr *ngFor="let dado of listAgenciasInativas">
                  <td>{{dado.Id}}</td>
                  <td>{{dado.RazaoSocial}}</td>
                  <td>{{dado.NomeFantasia}}</td>
                </tr>
              </tbody>
            </table>
            <hr>

            <paginacao [paginacao]="paginacao" (alterarPagina)="buscarPagina($event)"></paginacao>

          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
